import { SET_PENSIONIERUNG_DATA } from "../constants/actions";
import { FinanceBoxProps } from "../types";
import { api } from "../utils/api";

export type PensionierungData = {
  title: string;
  text: string;
  retirementBox: {
    amount: number;
    defaultRetirementAge: number;
    subTitle: string;
    projectedGraph: {
      date: string;
      year: number;
      age: number;
      value: number;
    }[];
    link: string;
    linkText: string;
    isVisible: boolean;
  };
  actionsBox: {
    title: string;
    text: string;
    isVisible: boolean;
    actionList: {
      title: string;
      text: string;
      link: string;
      linkText: string;
    }[];
  };
  simulationBox: {
    title: string;
    toolTip: string;
    text: string;
    link: string;
    linkText: string;
    isVisible: boolean;
  };
  financeExpertBox: FinanceBoxProps;
  purchaseLinkBox: {
    title: string;
    text: string;
    link: string;
    linkText: string;
    isVisible: boolean;
  };
  contactBox: {
    title: string;
    text: string;
    link: string;
    linkText: string;
    isVisible: boolean;
  };
  retirementPageContentBox: {
    content: string;
  };
};

export const getPensionierungData = (payload) => {
  return async function (dispatch) {
    try {
      const response: { data: { data: PensionierungData } } = await api.get(
        "pages/retirement"
      );
      dispatch({
        type: SET_PENSIONIERUNG_DATA,
        payload: response.data.data,
      });
      return response;
    } catch (err) {
      return err;
    }
  };
};
